import React, { useState } from 'react';
import { Form, Input, Radio, DatePicker, FormInstance } from 'antd';
import GatewaySelect from '../../common/GatewaySelect';
import LocaltionSelect from '../../common/LocationSelect';
import { Dayjs } from 'dayjs'
import UserLookup from '../../common/UserLookup';

const App: React.FC<{
  isEdit?: boolean,
  initialValues?: Partial<ProjectFormValue>,
  form: FormInstance
}> = ({ initialValues, form }) => {
  return (
    <Form
      form={form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 16 }}
      style={{ maxWidth: 600 }}
      initialValues={initialValues}
      autoComplete="off"
    >
      <Form.Item<ProjectFormValue>
        label="展会名称"
        name="name"
        rules={[{ required: true }]}
      >
        <Input placeholder='请输入展会名称' />
      </Form.Item>

      <Form.Item<ProjectFormValue>
        label="展馆"
        name="organizationId"
        rules={[{ required: true }]}
      >
        <LocaltionSelect />
      </Form.Item>

      <Form.Item<ProjectFormValue>
        label="展会人员"
        name="users"
        rules={[{ required: true }]}
      >
        <UserLookup initOptions={
          (initialValues?.userList || []).map(i => ({
            label: i.username, value: i.userId
          }))
        } placeholder='请输入姓名搜索人员' mode='multiple' />
      </Form.Item>

      <Form.Item<ProjectFormValue>
        label="开始日期"
        name="startDate"
        rules={[{ required: true },
        ({ getFieldValue }) => ({
          validator(_, value) {
            const endDate: Dayjs = getFieldValue('endDate')
            const startDate: Dayjs = getFieldValue('startDate')
            if (!endDate || !startDate) return Promise.resolve();
            const invalid = endDate.valueOf() < startDate.valueOf()
            if (invalid) {
              return Promise.reject(new Error('结束日期必须晚于开始日期'));
            }
            return Promise.resolve();
          },
        })]}
      >
        <DatePicker format={'YYYY-MM-DD'} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item<ProjectFormValue>
        label="结束日期"
        name="endDate"
        rules={[{ required: true },
        ({ getFieldValue }) => ({
          validator(_, value) {
            const endDate: Dayjs = getFieldValue('endDate')
            const startDate: Dayjs = getFieldValue('startDate')
            if (!endDate || !startDate) return Promise.resolve();
            const invalid = endDate.valueOf() < startDate.valueOf()
            if (invalid) {
              return Promise.reject(new Error('结束日期必须晚于开始日期'));
            }
            return Promise.resolve();
          },
        })
        ]}
      >
        <DatePicker format={'YYYY-MM-DD'} style={{ width: '100%' }} />
      </Form.Item>
      {/* <Form.Item<ProjectFormValue>
        label="网络类型"
        name="is5G"
        rules={[{ required: true }]}
      >
        <Radio.Group onChange={e => setIs5G(e.target.value)} options={[{ value: false, label: '4G' }, { value: true, label: '5G' }]} />
      </Form.Item> */}
      {
        // is5G === true &&
        <Form.Item<ProjectFormValue>
          label="网关"
          name="gateways"
          rules={[{ required: false }]}
        >
          <GatewaySelect isArrayValue />
        </Form.Item>
      }
      <Form.Item<ProjectFormValue>
        label="备注"
        name="description"
      >
        <Input.TextArea />
      </Form.Item>
    </Form>
  );
}

export default App;